module.exports = __webpack_public_path__ + "assets/Flared.a0148dcb10ed3b1c659aad40bca83f31.svg";